import { useState } from 'react';
import iconGringao from '../../assets/iconegringao.png';
import styles from './ImageTooltip.module.css';

const ImageTooltip = ({ src, alt, children, salesHistory, productCode, productDescription }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = (e) => {
    if (!src && !salesHistory) return;
    setShowTooltip(true);
    updatePosition(e);
  };

  const handleMouseMove = (e) => {
    if (showTooltip) {
      updatePosition(e);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const updatePosition = (e) => {
    const tooltipWidth = salesHistory ? 500 : 320; // Wider if showing history
    const tooltipHeight = salesHistory ? 550 : 320; // Taller to show all 12 months
    const margin = 15;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    let left = e.clientX + 20;
    let top = e.clientY - tooltipHeight / 2;

    // Se sair pela direita, mostra à esquerda do cursor
    if (left + tooltipWidth > windowWidth - margin) {
      left = e.clientX - tooltipWidth - 20;
    }

    // Se sair pelo topo
    if (top < margin) {
      top = margin;
    }

    // Se sair por baixo
    if (top + tooltipHeight > windowHeight - margin) {
      top = windowHeight - tooltipHeight - margin;
    }

    setPosition({ top, left });
  };

  const imageSrc = (!src || src === 'null' || src === 'undefined' || src === null) ? iconGringao : src;

  return (
    <div
      className={styles.container}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {children}

      {showTooltip && (
        <div
          className={styles.tooltip}
          style={{
            left: `${position.left} px`,
            top: `${position.top} px`,
            width: salesHistory ? '500px' : '320px',
            display: 'flex',
            gap: '15px',
            padding: '15px',
            flexDirection: salesHistory ? 'row' : 'column'
          }}
        >
          <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {/* Product Info Header */}
            {(productCode || productDescription) && (
              <div style={{
                borderBottom: '2px solid #dee2e6',
                paddingBottom: '8px',
                marginBottom: '5px'
              }}>
                {productCode && (
                  <div style={{
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    color: '#495057'
                  }}>
                    {productCode}
                  </div>
                )}
                {productDescription && (
                  <div style={{
                    fontSize: '0.75rem',
                    color: '#6c757d',
                    marginTop: '2px',
                    lineHeight: '1.2'
                  }}>
                    {productDescription}
                  </div>
                )}
              </div>
            )}

            {/* Product Image */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img
                src={imageSrc}
                alt={alt || 'Preview'}
                className={styles.tooltipImage}
                style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'contain' }}
              />
            </div>
          </div>

          {salesHistory && (
            <div style={{ flex: '1', fontSize: '0.85rem', overflowY: 'auto', maxHeight: '500px' }}>
              <h6 className="mb-2 border-bottom pb-1 text-dark fw-bold">Histórico 12 Meses</h6>
              <table className="table table-sm table-borderless mb-0" style={{ fontSize: '0.8rem' }}>
                <tbody>
                  {salesHistory.map((hist, index) => (
                    <tr
                      key={`${hist.ano} -${hist.mes} `}
                      style={{
                        backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'
                      }}
                    >
                      <td className="py-1 ps-2" style={{ width: '40%' }}>{hist.mesNome}/{hist.ano}</td>
                      <td className="fw-bold text-end py-1" style={{ width: '30%' }}>{hist.quantidade} un</td>
                      <td className="text-end py-1 pe-2" style={{ width: '30%' }}>
                        {index > 0 && (
                          <span className={hist.percentualChange >= 0 ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
                            {hist.percentualChange > 0 ? '+' : ''}{hist.percentualChange}%
                          </span>
                        )}
                        {index === 0 && <span className="text-muted">-</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageTooltip;
